export const blockNonNumericCharacters = (event: any) => {
  const isNonNumericChar = isNaN(Number(event.key)) && event.key !== 'Delete';

  if (isNonNumericChar) {
    event.preventDefault();
  }
};
